import type { SupportStudent } from '@repo/sdk/gen'
import { makeBreadcrumbFromCache } from '@repo/ui/components/query-breadcrumbs'
import { createFileRoute, notFound } from '@tanstack/react-router'
import i18n from '@/lib/i18n'
import { makeQueryKeys } from '@/query/query-keys'
import { supportStudentQueryOptions } from '../-query/query-options'
import { StudentCard } from './-components/student-card'

export const Route = createFileRoute('/(private)/assistenza/$userId/')({
	// The loader reads a student's personal data and logs the access: a hover
	// on a link must not run it, only opening the page.
	preload: false,
	loader: async ({ context, params }) => {
		try {
			await context.queryClient.ensureQueryData({
				...supportStudentQueryOptions(params.userId),
				revalidateIfStale: true
			})
		} catch (error) {
			if (
				typeof error === 'object' &&
				error !== null &&
				'code' in error &&
				error.code === 'support_student_not_found'
			) {
				throw notFound()
			}
			throw error
		}
	},
	staticData: {
		breadcrumb: ({ params, queryClient }) =>
			makeBreadcrumbFromCache<SupportStudent>(
				queryClient,
				makeQueryKeys.support.student(params.userId ?? ''),
				(student) =>
					student.account.name ||
					student.account.email ||
					i18n.t('admin-support:card.title')
			)
	},
	component: SupportStudentPage
})

function SupportStudentPage() {
	const { userId } = Route.useParams()
	return <StudentCard userId={userId} />
}
